var compatibility = require('./helpers/compatibility');
var authCheck = require('./helpers/auth');

var events = require('./core/events');
var domReady = require('./helpers/domready');

var Analytics = require('./core/analytics');
var Sentry = require('./core/sentry');
var Development = require('./core/dev');

var Navigation = require('./core/navigation');

var NotificationsTicker = require('./ui/notificationsticker');
var Modal = require('./ui/modal');
var ClampedContent = require('./ui/clamped-content');

var DynamicDocument = require('./ui/dynamicdocument');
var BffMenuBar = require('./ui/bffmenubar');
var FixedGlobalNav = require('./ui/fixedglobalnav');
var Hamburger = require('./ui/hamburger');
var Totaliser = require('./ui/totaliser');

var SiteSearch = require('./ui/sitesearch');

var MiniSchedule = require('./ui/minischedule');
var SlideDeck = require('./ui/slidedeck');

var ScheduleNavigation = require('./ui/schedulenavigation');
var ShowsGrid = require('./ui/showsgrid');

var Twitter = require('./ui/twitter');
var SharePopup = require('./ui/sharepopup');
var DonationPrompt = require('./ui/donation-prompt');
var DonationConfirmation = require('./ui/donation-confirmation');
var InvokeDonation = require('./ui/invokedonation');
var KindfulDonation = require('./ui/kindful-donation');
var KindfulLinkHandler = require('./ui/kindful-link-handler');

// TODO: PodcastInfo, AddReminder, AddFeed could be merged
var PodcastInfo = require('./ui/podcast-info');
var AddReminder = require('./ui/add-reminder');
var AddFeed = require('./ui/add-feed');
var SubscribeDialog = require('./ui/subscribe-dialog');

var Themeable = require('./ui/themeable');
var ThemeToggle = require('./ui/theme-toggle');

var fontHelper = require('./helpers/fontStylesheet');

// Analytics & Error Logging
var analytics = new Analytics();
new Sentry();

// Helpers if we're in dev mode
new Development();

// Init Components
function initGlobalComponents() {
  const html = document.body.parentElement;
  const body = document.body;
  const navManager = new Navigation(document.body);
  navManager.contentSelector = '.DynamicDocument-content';

  // Lazy-load Flama to prevent FOIT
  fontHelper.loadFonts();

  DynamicDocument.discover(html);
  FixedGlobalNav.discover(html);
  Themeable.discover(html);
  ThemeToggle.discover(body);

  Hamburger.discover(body);
  BffMenuBar.discover(body);
  NotificationsTicker.discover(body);
  SiteSearch.discover(body);
  DonationPrompt.discover(body);
  DonationConfirmation.discover(body);
  KindfulDonation.discover(body);
  KindfulLinkHandler.discover(body);
  Totaliser.discover(body);
}

function initContentComponents() {
  var body = document.body;

  MiniSchedule.discover(body);
  SlideDeck.discover(body);
  ShowsGrid.discover(body);
  ScheduleNavigation.discover(body);
  Modal.discover(body);
  ClampedContent.discover(body);

  Twitter.discover(body);
  InvokeDonation.discover(body);
  SharePopup.discover(body);

  PodcastInfo.discover(body);
  SubscribeDialog.discover(body);
  AddReminder.discover(body);
  AddFeed.discover(body);
}

// TODO: Maybe properly componentise this.
authCheck();

// Don't initialize app if browsing is missing features
if (compatibility()) {
  // TODO: Add “discover” to UI components.
  domReady(function () {
    initGlobalComponents();
    initContentComponents();
  });

  document.addEventListener(events.navigationRequestEnded, function (e) {
    if (e.detail.didNavigate) {
      initContentComponents();
    }
  });
} else {
  analytics.legacyBrowserImpression();
  document.body.className += ' u-noJs';
}



//////////////////
// WEBPACK FOOTER
// ./src/js/index.js
// module id = 124
// module chunks = 0